export default __webpack_public_path__ + "static/media/bmr-men.f1b1a709.png";